export interface CalendarState {
  allCountries: any;
  allCities: any;
  calendar: any;
  yearCalendar: any;
  postPracticeCalendar: any;
  loading: boolean;
  message: string;
}

export enum CalendarActionType {
  START_REQUEST = "START_REQUEST",
  ALL_COUNTRIES_LOADED = "ALL_COUNTRIES_LOADED",
  ALL_CITY_LOADED = "ALL_CITY_LOADED",
  CALENDAR_LOADED = "CALENDAR_LOADED",
  CALENDAR_LOADED_FROM_LOCAL_STORAGE = "CALENDAR_LOADED_FROM_LOCAL_STORAGE",
  YEAR_CALENDAR_LOADED = "YEAR_CALENDAR_LOADED",
  POST_PRACTICE_CALENDAR_LOADED = "POST_PRACTICE_CALENDAR_LOADED",
  FINISH_REQUEST = "FINISH_REQUEST",
}
